const DATE_TIME_FORMAT = new Intl.DateTimeFormat('en-US', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZoneName: 'short'
});

const DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  timeZoneName: 'short'
});

const parseDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const localDateTimeInputToUtcIso = (value) => {
  const date = parseDate(value);
  return date ? date.toISOString() : '';
};

export const utcIsoToLocalDateTimeInput = (value) => {
  const date = parseDate(value);
  if (!date) return '';

  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};

export const formatDateTime = (value) => {
  const date = parseDate(value);
  return date ? DATE_TIME_FORMAT.format(date) : 'Not set';
};

export const formatDate = (value) => {
  const date = parseDate(value);
  return date ? DATE_FORMAT.format(date) : 'Not set';
};

export const minutesToSeconds = (minutes) => {
  const parsed = Number(minutes);
  if (!Number.isFinite(parsed)) return 0;
  return Math.round(parsed * 60);
};

export const secondsToMinutes = (seconds) => {
  const parsed = Number(seconds);
  if (!Number.isFinite(parsed) || parsed <= 0) return 60;
  return Math.round(parsed / 60);
};

export const formatDuration = (seconds) => {
  const totalSeconds = Number(seconds);
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return 'Not set';

  const rounded = Math.round(totalSeconds);
  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  const remainingSeconds = rounded % 60;

  if (hours > 0 && remainingSeconds > 0) {
    return `${hours} hr ${minutes} min ${remainingSeconds} sec`;
  }

  if (hours > 0) {
    return `${hours} hr ${minutes} min`;
  }

  if (minutes > 0 && remainingSeconds > 0) {
    return `${minutes} min ${remainingSeconds} sec`;
  }

  if (minutes > 0) {
    return `${minutes} min`;
  }

  return `${remainingSeconds} sec`;
};
